import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import useResponsive from 'src/hooks/useResponsive';

export const Search = ({ onChange }) => {
  const [value, setValue] = useState('');
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    onChange && onChange(value);
  }, [value]);

  const { t } = useTranslation();

  return (
    <Box variant="outlined" sx={{ m: 1, p: 0, minWidth: 200 }}>
      <TextField
        size="small"
        placeholder={t('search')}
        value={value}
        sx={{ width: !isDesktop ? '100%' : 200 }}
        onChange={(e) => setValue(e.target.value)}
        InputProps={{
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton size="small" edge="end" color="primary" onClick={() => setValue('')}>
                <Iconify icon={'eva:trash-outline'} />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </Box>
  );
};
